import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 全局样式
import "./styles/index.scss";

// 路由权限
import "./permission.js";

//去除touchstart 谷歌提示
import 'default-passive-events'; 

//去除 preventDefault() 方法警报提示 
import './utils/BrowserPatch';

import locale from 'element-plus/lib/locale/lang/zh-cn' //中文

const app = createApp(App)

app.use(ElementPlus,{locale})
app.use(ElementPlus)
app.use(store)
app.use(router)


app.mount('#app')

//全局图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
